import { useDispatch } from 'react-redux';
import type { IRootDispatch } from '../../../store/models';
import { hasLoadedDeferred } from '../../../store/UserState.model';

/**
   * Returns a function for applying eligible coupons to the userState model
   * by querying the coupon_eligibility_check route and saving the response's code
   * to the userState model (along with the source of the call), as well as
   * localStorage and the remote state manager (if logged in)
  */
const useApplyDiscountCode = () => {
  const { clientPromotions } = useDispatch<IRootDispatch>();
  return async (source: string, code?: string, rewardId?: number) => {
    await hasLoadedDeferred.promise;
    return clientPromotions.addDiscountCode({
      discountCode: code,
      source,
      appointmentCost: undefined,
      rewardId,
    });
  };
};

export default useApplyDiscountCode;
